import { render, staticRenderFns } from "./AdminSideBar.vue?vue&type=template&id=2d2e0148&scoped=true"
import script from "./AdminSideBar.vue?vue&type=script&lang=js"
export * from "./AdminSideBar.vue?vue&type=script&lang=js"
import style0 from "./AdminSideBar.vue?vue&type=style&index=0&id=2d2e0148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e0148",
  null
  
)

export default component.exports